import { fromTheme, Icon, nativeOnlyStyles, styled, Text, View, webOnlyStyles } from 'lib_ui-primitives';
import { nativeOnlyProperties } from 'lib_ui-services';

export const MultiPickerTransaction = styled(View).attrs({ name: 'multi-picker-transaction-grid' })`
    padding-top: ${fromTheme('viewPadding')};
    background-color: ${fromTheme('backgroundColorLighter')};
    width: 100%;
    flex-direction: column;
    flex-grow: 1;
`;

let SpreadLeftToRight = styled(View)`
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: ${fromTheme('viewMarginMore')};
`;
SpreadLeftToRight = nativeOnlyStyles(SpreadLeftToRight)`
    padding-left: ${fromTheme('viewPadding')};
`;
SpreadLeftToRight = webOnlyStyles(SpreadLeftToRight)`
    padding-left: ${fromTheme('formField', 'padding', 'left')};
`;
export { SpreadLeftToRight };

export const Total = styled(View)`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: ${fromTheme('viewPadding')};
    flex-shrink: 0;
`;

export const TotalLabel = styled(Text).attrs(
    nativeOnlyProperties({
        numberOfLines: 1
    })
)`
    color: ${fromTheme('colorScheme', 'primary')};
    font-size: ${fromTheme('fontSizeSmall')};
`;

export const TotalNumber = styled(Text)`
    color: ${fromTheme('colorScheme', 'primary')};
    font-size: ${fromTheme('fontSizeLarge')};
`;

export const CountRow = styled(View)`
    flex-direction: row;
    align-items: center;
`;
CountRow.displayName = 'CountRow';

export const OfflineIcon = styled(Icon).attrs({ name: 'cloud-off', size: 'sm', color: 'currentColor' })`
    color: ${fromTheme('colorScheme', 'primary')};
`;
OfflineIcon.displayName = 'OfflineIcon';

export const ScanButton = styled(View)`
    padding: ${fromTheme('viewPadding')};
    margin-left: ${fromTheme('viewPadding')};
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
`;
ScanButton.displayName = 'ScanButton';

